
const strPattern = ({pattern, str})=>{
	let patt
	switch(pattern){
		case 'email':
			patt = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
			break
		case 'alphanumspace':
			patt = /^[a-zA-Z0-9\s]*$/gi
			break
		default:
			throw new Error(`${prop.pattern} is not recognized`)
	}
	return patt.test(str)
}

export default {
	strPattern
}


// WEBPACK FOOTER //
// ./src/utility/validate.js